import type { CSSProperties, FC } from 'react';
import React from 'react';
import { useDrag } from "react-dnd";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import User from '../../models/user.model';
import { NftDropped } from '../../pages/nfts/store/nfts.actions';
import { NFT } from '../../pages/nfts/store/nfts.reducer';
import { Web3ContextType } from '../../providers/context.types';
import { Web3Context } from '../../providers/web3.context';
import { AppState } from '../../store/root.reducer';

type NftThumbnailProps = {
    uri: string;
    name: string;
    tokenId: number;
}

const style: CSSProperties = {
    textAlign: 'center',
    margin: '10px'
}

interface DropResult {
    name: string
}

export const NftThumbnail = ({uri, name, tokenId}: NftThumbnailProps) => {
    const dispatch = useDispatch();
    const { selectedNFT, walletTokens } = useSelector((state: AppState) => state.nft);
    const { address } = React.useContext(Web3Context) as Web3ContextType;
    
    let isOwner = false;
    if(selectedNFT && address) {
        isOwner = (selectedNFT as NFT).owner === address;
    }

    const [{isDragging}, drag] = useDrag(() => ({
        type: 'NFT',
        item: {tokenId},
        end: (item, monitor) => {
            console.log('endofdragging');
            const dropResult = monitor.getDropResult<DropResult>();
            if(item && dropResult && (isOwner || !selectedNFT)) {
                const selectedNft = walletTokens.find(nft => nft.tokenId === tokenId);
                console.log('filtered: ', selectedNft);
                dispatch(NftDropped(selectedNft));
            }   
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId()
        })
    }));

    const opacity = isDragging ? 0.4 : 1;

    return (
        <>
            <div ref={drag} style={{...style, opacity}} data-testid={`NFT`}>
                <img src={uri} alt={name}/>
                <div>{name}</div>
            </div>
        </>
    )
}